import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

interface ReportLatenessParams {
  interviewId: string;
}

export function useReportInterviewLateness(
  options: UseMutationOptions<unknown, AxiosError, ReportLatenessParams> = {}
) {
  return useMutation({
    mutationFn: async (params) => {
      const { interviewId } = params;

      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/interviews/${interviewId}/report-lateness`,
        requestSchema: z.unknown(),
        responseSchema: z.unknown(),
      });

      return response.data;
    },
    ...options,
  });
}
